/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ComponentConfigSpecLimitsInner } from './componentConfigSpecLimitsInner';
import { ComponentConfigSpecSettingsInner } from './componentConfigSpecSettingsInner';
import { ComponentConfigSpecCompliance } from './componentConfigSpecCompliance';
import { ComponentConfigSpecServiceConsole } from './componentConfigSpecServiceConsole';
import { ComponentConfigSpecCommerce } from './componentConfigSpecCommerce';
import { ComponentConfigEnforcementSpec } from './componentConfigEnforcementSpec';
import { ComponentConfigSpecFeatureFlagsInner } from './componentConfigSpecFeatureFlagsInner';


export interface ComponentConfigSpec { 
    /**
     * Component ID
     */
    component_id?: string;
    /**
     * Organization Id.
     */
    org_id?: string;
    auth?: object;
    commerce?: ComponentConfigSpecCommerce;
    compliance?: ComponentConfigSpecCompliance;
    /**
     * Current Timestamp
     */
    current_ts?: Date;
    feature_flags?: Array<ComponentConfigSpecFeatureFlagsInner>;
    /**
     * Generation Count
     */
    generation_count?: number;
    limits?: Array<ComponentConfigSpecLimitsInner>;
    service_console?: ComponentConfigSpecServiceConsole;
    settings?: Array<ComponentConfigSpecSettingsInner>;
    enforcement?: ComponentConfigEnforcementSpec;
}

